import React, { useState } from "react";
import styled from "styled-components";
import { Button, Input, Radio, Checkbox } from "antd";
import { Content, MainContainer, MainContent } from "../../../styles/styles";
import { KoHeadline } from "../../../styles/sharedStyles";
import SideBar from "../../../components/nav/SideBar";
import { useNavigationStore } from "store/navigationStore";
import { useNavigate, useSearchParams } from "react-router-dom";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const PaymentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const SummaryCard = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #e5e5e5;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
  width: 100%;
  max-width: 1096px;
`;

const SummaryHeader = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
`;

const PlanName = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #4F7EFF;
  margin-bottom: 8px;
`;

const PlanPriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

const PriceGroup = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
`;

const PlanPrice = styled.span`
  font-size: 24px;
  font-weight: 700;
  color: #000;
`;

const PlanPeriod = styled.span`
  font-size: 14px;
  color: #666;
`;

const BillingInfo = styled.div`
  font-size: 14px;
  color: #666;
`;

const FormSection = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 32px;
  border: 1px solid #e5e5e5;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
  
  display: flex;
  flex-direction: row;
  gap: 40px;
  width: 100%;
  max-width: 1096px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 32px;
  }
`;

const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  flex: 1;
  min-width: 0;
`;

const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  flex: 1;
  min-width: 0;
`;

const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 10px;
  gap: 10px;
  width: 100%;
`;

const SectionTitle = styled.h3`
  margin: 0;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 130%;
  color: #000000;
`;

const FormList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 10px;
  gap: 24px;
  width: 100%;
`;

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 20px;
  width: 100%;
`;

const InputArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  width: 100%;
`;

const InputLabel = styled.label`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  display: flex;
  align-items: center;
  color: #000000;
  width: 100%;
`;

const StyledInput = styled(Input)`
  padding: 8px 16px;
  height: 42px;
  background: #FFFFFF;
  border: 1px solid #DBDCE2;
  border-radius: 6px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  width: 100%;
  
  &::placeholder {
    color: #A5A5AE;
  }
  
  &:focus {
    border-color: #4B5EFF;
    box-shadow: 0 0 0 2px rgba(75, 94, 255, 0.1);
  }
`;

const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  width: 100%;
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

const PaymentMethodArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  width: 100%;
`;

const RadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 100%;
`;

const RadioGroup = styled(Radio.Group)`
  width: 100%;
  
  .ant-radio-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: #000000;
  }
  
  .ant-radio {
    margin-right: 8px;
  }
  
  .ant-radio-checked .ant-radio-inner {
    background: #4B5EFF;
    border-color: #4B5EFF;
  }
`;

const ExistingCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;
  
  width: 100%;
  height: 42px;
  
  background: #FFFFFF;
  border: 1px solid #DBDCE2;
  border-radius: 6px;
  
  margin-top: 8px;
`;

const ExistingCardInfo = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #000000;
`;

const DeleteButton = styled.button`
  background: transparent;
  border: none;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  text-decoration-line: underline;
  color: #A5A5AE;
  cursor: pointer;
  
  &:hover {
    color: #727272;
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 100%;
  margin-top: 20px;
`;

const StyledCheckbox = styled(Checkbox)`
  .ant-checkbox {
    border-radius: 4px;
  }
  
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #4B5EFF;
    border-color: #4B5EFF;
  }
  
  .ant-checkbox:hover .ant-checkbox-inner {
    border-color: #4B5EFF;
  }
  
  .ant-checkbox-wrapper {
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: #000000;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  width: 100%;
`;

const BackButton = styled(Button)`
  /* 이전 버튼 스타일 */
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;
  
  height: 56px;
  background: #FFFFFF;
  border: 1px solid #DBDCE2;
  border-radius: 8px;
  
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #727272;
  min-width: 120px;
  
  &:hover {
    background: #F8F9FA !important;
    border-color: #DBDCE2 !important;
    color: #727272 !important;
  }
  
  &:focus {
    background: #F8F9FA !important;
    border-color: #4B5EFF !important;
    color: #727272 !important;
    box-shadow: 0 0 0 2px rgba(75, 94, 255, 0.1);
  }
`;

const PayButton = styled(Button)`
  /* 결제 버튼 스타일 */
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;
  
  height: 56px;
  background: #4B5EFF;
  border: 1px solid #4B5EFF;
  border-radius: 8px;
  
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #FFFFFF;
  min-width: 120px;
  
  &:hover {
    background: #3B4EEF !important;
    border-color: #3B4EEF !important;
    color: #FFFFFF !important;
  }
  
  &:focus {
    background: #3B4EEF !important;
    border-color: #3B4EEF !important;
    color: #FFFFFF !important;
    box-shadow: 0 0 0 2px rgba(75, 94, 255, 0.1);
  }
  
  &:disabled {
    background: #E5E5E5 !important;
    border-color: #E5E5E5 !important;
    color: #A5A5AE !important;
    cursor: not-allowed;
  }
`;

const PaymentFormPage = () => {
  const { isCollapsed } = useNavigationStore();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const planName = searchParams.get('plan') || 'Team';
  
  const [paymentMethod, setPaymentMethod] = useState('existing');
  const [agreementChecked, setAgreementChecked] = useState(false);
  const [formData, setFormData] = useState({
    cardNumber: '',
    expiryMonth: '',
    expiryYear: '',
    cvc: '',
    cardHolder: '',
    email: '',
    address: '',
    phone: ''
  });

  const planInfo = {
    'team': {
      name: 'Team 플랜',
      price: '149,000원',
      period: '/월 (VAT 별도)',
      billingDate: '매월 15일 결제'
    },
    'pro': {
      name: 'Pro 플랜',
      price: '349,000원',
      period: '/월 (VAT 별도)',
      billingDate: '매월 15일 결제'
    }
  };

  const currentPlan = planInfo[planName.toLowerCase() as keyof typeof planInfo] || planInfo.team;

  const handleInputChange = (field: string, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleDeleteCard = () => {
    setPaymentMethod('new');
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handlePayment = () => {
    // 결제 로직 구현
    console.log('결제 처리:', { planName, paymentMethod, formData });
    // 결제 완료 후 처리
    navigate('/billing', { replace: true });
  };

  return (
    <MainContainer>
      <Content $isCollapsed={isCollapsed}>
        <SideBar />
        <MainContent>
          <PageContainer>
            <KoHeadline>결제·구독 관리</KoHeadline>
            
            <PaymentSection>
              <SummaryCard>
                <SummaryHeader>최종 결제 요약</SummaryHeader>
                <PlanName>{currentPlan.name}</PlanName>
                <PlanPriceRow>
                  <PriceGroup>
                    <PlanPrice>{currentPlan.price}</PlanPrice>
                    <PlanPeriod>{currentPlan.period}</PlanPeriod>
                  </PriceGroup>
                  <BillingInfo>{currentPlan.billingDate}</BillingInfo>
                </PlanPriceRow>
              </SummaryCard>

              <FormSection>
                <LeftSection>
                  <SectionHeader>
                    <SectionTitle>결제 정보 입력</SectionTitle>
                  </SectionHeader>
                  
                  <FormList>
                    <FormContent>
                          <PaymentMethodArea>
                            <RadioContainer>
                              <RadioGroup 
                                value={paymentMethod} 
                                onChange={(e) => setPaymentMethod(e.target.value)}
                              >
                                <Radio value="existing">기존 결제 수단</Radio>
                                <Radio value="new">새 카드 등록</Radio>
                              </RadioGroup>
                            </RadioContainer>
                            
                            {paymentMethod === 'existing' && (
                              <ExistingCardContainer>
                                <ExistingCardInfo>XXXX-XXXX-1515-4242</ExistingCardInfo>
                                <DeleteButton onClick={handleDeleteCard}>삭제</DeleteButton>
                              </ExistingCardContainer>
                            )}
                          </PaymentMethodArea>
                          
                          {paymentMethod === 'new' && (
                            <>
                              <InputArea>
                                <InputLabel>카드 번호</InputLabel>
                                <StyledInput 
                                  placeholder="xxxx-xxxx-1515-4242"
                                  value={formData.cardNumber}
                                  onChange={(e) => handleInputChange('cardNumber', e.target.value)}
                                />
                              </InputArea>
                              
                              <FormRow>
                                <InputArea>
                                  <InputLabel>유효기간</InputLabel>
                                  <StyledInput 
                                    placeholder="MM/YY"
                                    value={`${formData.expiryMonth}${formData.expiryYear ? '/' + formData.expiryYear : ''}`}
                                    onChange={(e) => {
                                      const value = e.target.value.replace('/', '');
                                      if (value.length <= 2) {
                                        handleInputChange('expiryMonth', value);
                                        handleInputChange('expiryYear', '');
                                      } else {
                                        handleInputChange('expiryMonth', value.slice(0, 2));
                                        handleInputChange('expiryYear', value.slice(2, 4));
                                      }
                                    }}
                                  />
                                </InputArea>
                                <InputArea>
                                  <InputLabel>CVC</InputLabel>
                                  <StyledInput 
                                    placeholder="XXX"
                                    value={formData.cvc}
                                    onChange={(e) => handleInputChange('cvc', e.target.value)}
                                  />
                                </InputArea>
                              </FormRow>
                              
                              <InputArea>
                                <InputLabel>카드 소유자</InputLabel>
                                <StyledInput 
                                  placeholder="카드에 표시된 이름을 입력하세요"
                                  value={formData.cardHolder}
                                  onChange={(e) => handleInputChange('cardHolder', e.target.value)}
                                />
                              </InputArea>
                            </>
                          )}
                    </FormContent>
                  </FormList>
                </LeftSection>

                <RightSection>
                  <SectionHeader>
                    <SectionTitle>청구서 수신정보</SectionTitle>
                  </SectionHeader>
                  
                  <FormList>
                    <FormContent>
                      <InputArea>
                        <InputLabel>청구서 수신 이메일</InputLabel>
                        <StyledInput 
                          placeholder="billing@company.com"
                          value={formData.email}
                          onChange={(e) => handleInputChange('email', e.target.value)}
                        />
                      </InputArea>
                      
                      <InputArea>
                        <InputLabel>회사명</InputLabel>
                        <StyledInput 
                          placeholder="주식회사 오디온"
                          value={formData.address}
                          onChange={(e) => handleInputChange('address', e.target.value)}
                        />
                      </InputArea>
                      
                      <InputArea>
                        <InputLabel>사업자 등록번호</InputLabel>
                        <StyledInput 
                          placeholder="123-45-67890"
                          value={formData.phone}
                          onChange={(e) => handleInputChange('phone', e.target.value)}
                        />
                      </InputArea>
                    </FormContent>
                  </FormList>
                </RightSection>
              </FormSection>
            </PaymentSection>

            <CheckboxContainer>
              <StyledCheckbox 
                checked={agreementChecked}
                onChange={(e) => setAgreementChecked(e.target.checked)}
              >
                정기결제 및 이용약관에 동의합니다. (매월/연간 자동 결제)
              </StyledCheckbox>
            </CheckboxContainer>

            <ButtonGroup>
              <BackButton onClick={handleBack}>
                이전
              </BackButton>
              <PayButton 
                onClick={handlePayment}
                disabled={!agreementChecked}
              >
                결제
              </PayButton>
            </ButtonGroup>
          </PageContainer>
        </MainContent>
      </Content>
    </MainContainer>
  );
};

export default PaymentFormPage;